var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"customer-edit","toptitle":"Kunde bearbeiten","title":_vm.customer.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('customer-form',{attrs:{"customer":_vm.customer,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }